module.exports = __webpack_public_path__ + "static/img/noresult.f6bc7c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/teacherhomework/create/noresult.png
// module id = +e3s
// module chunks = 1